import React from "react";

interface IQpTooltipProps extends React.HTMLAttributes<HTMLElement> {
    text: string;
    iconName?: string;
    iconFolder?: string;
    iconSize?: number;
    iconColor?: string;
    maxWidth?: string;
}

const QpTooltip: React.FC<IQpTooltipProps> = ({
    text,
    iconName,
    iconFolder,
    iconSize,
    iconColor,
    maxWidth,
    ...rest
}) => (
    <qp-tooltip
        data-text={text}
        data-icon-name={iconName}
        data-icon-folder={iconFolder}
        data-icon-size={iconSize}
        data-icon-color={iconColor}
        data-max-width={maxWidth}
        {...rest}
    ></qp-tooltip>
);

export default QpTooltip;
